var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotography(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 810",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;isolation:isolate;opacity:.3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 452,
    cy: 451.46,
    r: 191.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M810,180h-182.25l-82.35-90h-190.8l-82.35,90H90v540h720V180ZM450,675c-124.2,0-225-100.8-225-225s100.8-225,225-225,225,100.8,225,225-100.8,225-225,225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,810h720c49.5,0,90-40.5,90-90V180c0-49.5-40.5-90-90-90h-142.65L585,0h-270l-82.35,90H90C40.5,90,0,130.5,0,180v540c0,49.5,40.5,90,90,90M90,180h182.25l82.35-90h190.8l82.35,90h182.25v540H90V180ZM450,225c-124.2,0-225,100.8-225,225s100.8,225,225,225,225-100.8,225-225-100.8-225-225-225M450,585c-74.25,0-135-60.75-135-135s60.75-135,135-135,135,60.75,135,135-60.75,135-135,135"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotography);
export default __webpack_public_path__ + "static/media/photography.09a907a66d5ed01388edca785fe7bee0.svg";
export { ForwardRef as ReactComponent };